<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" md="12">
        <b-row>
          <b-col>
            <h3>{{ $t('EinstellungenProfil') }}</h3>
            <p>{{ $t('FrmProfil_Profil_Text') }}</p>
            <h3>{{ $t('Benutzername') }} / {{ $t('Passwort') }}</h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8" sm="12" class="mb-3">
            <b-form-input v-model="user.name" disabled />
          </b-col>
          <b-col md="4" sm="12" class="mb-3">
<!-- DB2020: nicht mehr notwendig
            <b-btn @click="changePW" :disabled="domSwitch">{{ $t('PWAendern') }}</b-btn>
-->
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h3>{{ $t('Emailadresse') }} / {{ $t('Sprache') }}</h3>
          </b-col>
          <b-col md="8" sm="12">
            <b-form-input v-model="domain.email" disabled class="mb-3" />
          </b-col>
          <b-col md="4" sm="12">
            <b-form-select
              id="email.language"
              v-model="domain.language"
              :options="languages"
              value-field="code"
              :text-field="$i18n.locale"
              disabled
              class="mb-3"
            />
          </b-col>
          <b-col sm="12">
            <b-btn
              @click="showEmail"
              variant="primary"
              :disabled="domSwitch"
              class="mb-3"
            >{{ $t('Bearbeiten') }}</b-btn>
            <b-modal
              ref="emailModal"
              :title="emailTitle"
              :hide-header-close="emailForced"
              :no-close-on-esc="emailForced"
              :no-close-on-backdrop="emailForced"
            >
              <p v-if="emailForced && $t('FrmProfil_Popup_Einleitung').length" v-html="$t('FrmProfil_Popup_Einleitung')"></p>
              <p v-if="emailForced" v-html="$t('FrmProfil_Popup_Email')"></p>
              <b-form>
                <b-form-group :label="$t('EmailadresseErfassen')" label-for="email">
                  <b-form-input
                    id="email"
                    v-model.trim="email.email"
                    type="email"
                    :state="emailState"
                    required
                    aria-describedby="emailFeedback"
                  />
                  <b-form-invalid-feedback
                    id="emailFeedback"
                  >{{ $t('FrmProfil_GueltigeEmailErfassen') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group :label="$t('EmailadresseBestaetigen')" label-for="email2">
                  <b-form-input
                    id="email2"
                    v-model.trim="email.email2"
                    type="email"
                    :state="emailConfirmed"
                    required
                    aria-describedby="email2Feedback"
                  />
                  <b-form-invalid-feedback
                    id="email2Feedback"
                  >{{ $t('FrmProfil_BeideEmailGleich') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-form>
              <b-form validated>
                <b-form-group :label="$t('Sprache')" label-for="language">
                  <b-form-select
                    id="language"
                    v-model="email.language"
                    :options="languages"
                    value-field="code"
                    :text-field="$i18n.locale"
                  />
                </b-form-group>
              </b-form>
              <div slot="modal-footer">
                <b-btn @click="hideEmail" v-if="! emailForced">{{ $t('Abbrechen') }}</b-btn>
                <b-btn
                  @click="saveEmail"
                  variant="primary"
                  :disabled="! (emailState && emailConfirmed)"
                >{{ $t('Speichern') }}</b-btn>
              </div>
            </b-modal>
          </b-col>
        </b-row>
<!-- DB2020: nicht mehr notwendig
        <b-row>
          <b-col cols="12">
            <label for="emailVersandVertrag">{{ $t('VertragEmailBenachrichtigung') }}</label>
          </b-col>
          <b-col md="4" sm="12">
            <b-form>
              <b-form-group>
                <b-form-select
                  id="emailVersandVertrag"
                  v-model="emailVersand.vertrag"
                  :options="emailVersand.options"
                  value-field="value"
                  :text-field="$i18n.locale"
                  @change="saveEmailVersandVertrag"
                />
              </b-form-group>
            </b-form>
          </b-col>
          <b-col md="8" sm="0"></b-col>
        </b-row>
        <b-row v-if="isSAPKreditor">
          <b-col cols="12">
            <label for="emailVersandZulagen">{{ $t('ZulagenEmailBenachrichtigung') }}</label>
          </b-col>
          <b-col md="4" sm="12">
            <b-form>
              <b-form-group>
                <b-form-select
                  id="emailVersandZulagen"
                  v-model="emailVersand.zulagen"
                  :options="emailVersand.options"
                  value-field="value"
                  :text-field="$i18n.locale"
                  @change="saveEmailVersandZulagen"
                />
              </b-form-group>
            </b-form>
          </b-col>

          <b-col md="8" sm="0"></b-col>
        </b-row>
        <b-row v-if="isSAPKreditor">
          <b-col cols="12">
            <label for="emailVersandZulagen">{{ $t('EinladungenEmailBenachrichtigung') }}</label>
          </b-col>
          <b-col md="4" sm="12">
            <b-form>
              <b-form-group>
                <b-form-select
                  id="einladungVersandEmail"
                  v-model="emailEinladungen"
                  :options="emailVersand.options"
                  value-field="value"
                  :text-field="$i18n.locale"
                  @change="saveEmailVersandZulagen"
                />
              </b-form-group>
            </b-form>
          </b-col>

          <b-col md="8" sm="0"></b-col>
        </b-row>
-->
      </b-col>
      <b-col lg="6" md="12">
        <h3>{{ $t('Adresse') }}</h3>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('Anrede')" label-for="anrede">
              <b-form-input id="anrede" v-model="adresse.anrede" disabled class="mb-3" />
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('Rechtsform')" label-for="rechtsform">
              <b-form-input
                id="rechtsform"
                v-model="adresse.rechtsform[$i18n.locale]"
                disabled
                class="mb-3"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('NameFirma')" label-for="name">
              <b-form-input id="name" v-model="adresse.name" disabled class="mb-3" />
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('VornameZusatz')" label-for="vorname">
              <b-form-input id="vorname" v-model="adresse.vorname" disabled class="mb-3" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('Adresse')" label-for="adresse">
              <b-form-input id="adresse" v-model="adresse.adresse" disabled class="mb-3" />
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('Zuhanden')" label-for="zuhanden">
              <b-form-input id="zuhanden" v-model="adresse.zuhanden" disabled class="mb-3" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('Adresszusatz')" label-for="adresszusatz">
              <b-form-input id="adresszusatz" v-model="adresse.adresszusatz" disabled class="mb-3" />
            </b-form-group>
          </b-col>
          <b-col md="2" sm="4">
            <b-form-group :label="$t('PLZ')" label-for="plz">
              <b-form-input id="plz" v-model="adresse.plz" disabled class="mb-3" />
            </b-form-group>
          </b-col>
          <b-col md="4" sm="8">
            <b-form-group :label="$t('Ort')" label-for="ort">
              <b-form-input id="ort" v-model="adresse.ort" disabled class="mb-3" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3" sm="6">
            <b-form-group :label="$t('Telefon') + ' 1'" label-for="telefon1">
              <b-form-input id="telefon1" v-model="adresse.telefon1" disabled class="mb-3" />
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group :label="$t('Telefon') + ' 2'" label-for="telefon2">
              <b-form-input id="telefon2" v-model="adresse.telefon2" disabled class="mb-3" />
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group :label="$t('Telefon') + ' 3'" label-for="telefon3">
              <b-form-input id="telefon3" v-model="adresse.telefon3" disabled class="mb-3" />
            </b-form-group>
          </b-col>
        </b-row>
        <h3>{{ $t('Kreditor') }}</h3>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('ZulageVerkehrsmilch')" label-for="kreditor">
              <b-form-input id="kreditor" v-model="domain.creditor" disabled class="mb-3" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { bus, axios, apiURL } from "../main";
export default {
  name: "profil",
  data() {
    return {
      domain: this.$store.state.userStore.domain,
      user: this.$store.state.userStore.user,
      email: {
        email: "",
        email2: "",
        language: "de"
      },
      emailVersand: {
        vertrag: 1,
        zulagen: 1,
        einladungen: 1,
        options: [
          { value: 1, de: "ja", fr: "oui", it: "si" },
          { value: 0, de: "nein", fr: "non", it: "no" }
        ]
      },
      emailEinladung: {
        einladungen: 1, 
        options: [
          { value: 1, de: "ja", fr: "oui", it: "si" },
          { value: 0, de: "nein", fr: "non", it: "no" }
        ]
      },
      adresse: this.$store.state.userStore.adresse,
      adresseNeu: {},
      languages: [
        { code: "de", de: "Deutsch", fr: "Allemand", it: "Tedesco" },
        { code: "fr", de: "Französisch", fr: "Francais", it: "Francese" },
        { code: "it", de: "Italienisch", fr: "Italien", it: "Italiano" }
      ]
    };
  },
  computed: {
    emailEinladungen: {
      get: function() {
        return this.emailEinladung.einladungen;
      },
      set: function(newvalue) {
        this.emailEinladung.einladungen = newvalue;
        axios.get(apiURL + "userManager.cfc?method=setEmailSubscription", {
          params: { chnName: "Einladung", doSubscribe: newvalue }
        })
      }
    },
    emailState() {
      //const re = /[A-Za-z0-9.!#$%&'*/=?^_`{|}~+-]+@[A-Za-zäöüàéè0-9.-]+\.[A-Za-z]{2,63}$/
      const re = /[A-Za-z0-9.!#$%&'*/=?^_`{|}~+-]+@(([A-Za-zäöüàéè0-9-]+\.)+[A-Za-z]{2,63})$/
      return re.test(
        this.email.email
      )
    },
    domSwitch() {
      return this.$store.state.userStore.token.masterDomain > 0
    },
    emailForced() {
      return (
        this.$store.state.userStore.user.checkProfile > 0 &&
        this.$store.state.userStore.token.masterDomain === 0
      )
    },
    emailTitle() {
      if (this.emailForced) return this.$t('FrmProfil_Popup_Titel')
      else return this.$t('Email')
    },
    emailConfirmed() {
      return this.email.email2 === this.email.email && this.email.email !== ""
    },
    isSAPKreditor() {
      return (this.$store.state.zulagenStore.kreditor.kreditor.length > 0)
    }
  },
  methods: {
    changePW() {
      document.location.href =
        "/dbp/index.cfm?Nav=290&Type=Users&Mode=edit&PW=1&ID=" +
        this.$store.state.userStore.user.ID;
    },
    showEmail() {
      this.email.email = this.$store.state.userStore.domain.email.trim();
      this.email.email2 = this.$store.state.userStore.domain.email.trim();
      this.email.language = this.$store.state.userStore.domain.language;
      this.$refs.emailModal.show();
    },
    hideEmail() {
      this.$refs.emailModal.hide();
    },
    async saveEmail() {
      this.$refs.emailModal.hide();
      if (this.email.email === this.email.email2)
        await this.$store.dispatch("saveEmail", this.email);
      else bus.$emit("message", this.$t("EmailUngleich"));
    },
    async saveEmailVersandVertrag() {
      this.$nextTick(function() {
        // nextTick, da Wert sonst noch nicht gesetzt ist (@watch ist andere Möglichkeit)
        this.$store.dispatch(
          "setEmailVersandVertrag",
          this.emailVersand.vertrag
        );
      });
    },
    async saveEmailVersandZulagen() {
      this.$nextTick(function() {
        // nextTick, da Wert sonst noch nicht gesetzt ist (@watch ist andere Möglichkeit)
        this.$store.dispatch(
          "setEmailVersandZulagen",
          this.emailVersand.zulagen
        );
      });
    }
  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      await self.$store.dispatch("loadZulagen");
      this.emailVersand.vertrag = this.$store.state.userStore.domain.emailContract;
      this.emailVersand.zulagen = this.$store.state.zulagenStore.kreditor.emailVersand;
      axios
        .get(apiURL + "userManager.cfc?method=getEmailSubscription", {
          params: { chnName: "Einladung" }
        })
        .then(function(result) {
          self.emailEinladung.einladungen = result.data;
        });
    });
  },
  mounted() {
    if (this.emailForced) this.showEmail();
  }
};
</script>